import axios from "axios";
import { toast } from "react-toastify";

const api = axios.create();

// Request interceptor — attach the current token to every request
api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("adminToken");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor — handle 401 / "Invalid token" globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const serverError = error.response?.data?.error;
        const requestUrl = error.config?.url || "";

        const isUnauthorized =
            status === 401 ||
            (typeof serverError === "string" &&
                serverError.toLowerCase().includes("invalid token"));

        // Skip redirect for the login endpoint (wrong password → 401
        // is expected and handled by the login page itself)
        const isLoginRequest = requestUrl.includes("/admins/login");

        if (isUnauthorized && !isLoginRequest) {
            sessionStorage.clear();

            if (window.location.pathname !== "/login") {
                toast.warn("Session expired. Please log in again.", {
                    position: "top-center",
                    autoClose: 1500,
                });
                setTimeout(() => {
                    window.location.replace("/login");
                }, 600);
            }
        }

        return Promise.reject(error);
    }
);

export default api;